var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prototype-attribute-table',{attrs:{"attribute-name":"material"}})
}
var staticRenderFns = []

export { render, staticRenderFns }